import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/UI/Loading";
import { fetchBlogs } from "../../features/Blogs/BlogsSlice";
import AsideMenu from "./AsideMenu";
import BlogListItem from "./BlogListItem";

export default function Blogs() {
  const dispatch = useDispatch();
  const { isLoading, isError, blogs, error } = useSelector(
    (state) => state.blogs
  );
  const { sort, filter } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(fetchBlogs({ sort, filter }));
  }, [dispatch, sort, filter]);

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <Loading />;
  }

  if (!isLoading && isError) {
    content = <div className="col-span-12">{error}</div>;
  }
  if (!isLoading && !isError && blogs?.length > 0) {
    content = blogs.map((blog) => <BlogListItem key={blog.id} blog={blog} />);
  }

  return (
    <>
      {/* <!-- main --> */}
      <section className="wrapper">
        <AsideMenu />
        {/* <!-- posts container  --> */}
        <main className="post-container" id="lws-postContainer">
          {content}
        </main>
        {/* <!-- posts container ends --> */}
      </section>
    </>
  );
}
